// TODO: Can this be turned into a global function? I believe we are doing the same thing elsewhere.
document.addEventListener('DOMContentLoaded', function () {
  var options = {
    align: 'start',
    skipSnaps: false,
    dragFree: false,
    containScroll: 'keepSnaps',
  };

  var emblaNode = document.querySelector('.ecs-cards-carousel__content .embla');
  if (!emblaNode) return;

  var viewportNode = emblaNode.querySelector('.embla__viewport');
  var embla = EmblaCarousel(viewportNode, options);

  var dotsNode = document.querySelector('.ecs-cards-carousel__dots');
  var dotsArray = generateDots(dotsNode, embla.scrollSnapList());

  var selectedDotIndex = 0;
  dotsArray[selectedDotIndex].classList.add('ecs-cards-carousel__dot--selected');

  embla.on('select', function () {
    var previousDotIndex = selectedDotIndex;
    selectedDotIndex = embla.selectedScrollSnap();
    dotsArray[previousDotIndex].classList.remove('ecs-cards-carousel__dot--selected');
    dotsArray[selectedDotIndex].classList.add('ecs-cards-carousel__dot--selected');
  });

  dotsArray.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      embla.scrollTo(index);
    });
  });
  // Add click handlers for prev/next buttons
  const prevButton = document.querySelector('.ecs-cards-carousel__arrow--prev');
  const nextButton = document.querySelector('.ecs-cards-carousel__arrow--next');

  prevButton.addEventListener('click', function () {
    embla.scrollPrev();
  });

  nextButton.addEventListener('click', function () {
    embla.scrollNext();
  });
});
function generateDots(dotsNode, scrollSnaps) {
  var dotsHTML = scrollSnaps.reduce(function (acc) {
    return acc + '<button class="ecs-cards-carousel__dot" type="button"></button>';
  }, '');
  dotsNode.innerHTML = dotsHTML;
  return [].slice.call(dotsNode.querySelectorAll('.ecs-cards-carousel__dot'));
}
